import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createBlock as _createBlock, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["activity-id"]
const _hoisted_2 = { class: "self-review-activity-content" }
const _hoisted_3 = { class: "activity-button-wrapper" }
const _hoisted_4 = { class: "activity-button" }
const _hoisted_5 = { class: "activity-button-inner" }
const _hoisted_6 = {
  class: "complete-icon",
  key: "complete"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-ok" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-list" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "activity-description" }

import { ref, watch, onMounted } from "vue";
import { debug as d } from "debug";
import QuestionsModal from "../develop/questions-modal.vue";
import cms from "../../services/cms/cms";
import { Analytics } from "../../services/analytics/analytics";
import { CmsDevelopPage } from "../../services/cms/cms-type-definitions";
import { DevelopPlan } from "../../services/cms/develop-plan";


export default /*#__PURE__*/_defineComponent({
  __name: 'self-review-activity',
  props: {
    pageId: {},
    pageUid: {},
    mandatory: { type: Boolean },
    activityIds: { default: () => [] },
    selfReviewNumber: {},
    activityId: {},
    complete: { type: Boolean, default: false },
    developPageDoc: {}
  },
  emits: ["self-review-completed"],
  setup(__props: any, { emit: __emit }) {

const debug = d("cs.SelfReviewActivityComponent");

const props = __props;

const activityIds = ref<string[]>(props.activityIds ?? []);

const emit = __emit;

const associatedPlan = ref<DevelopPlan | null>(null);

const showModal = ref(false);

watch(
  () => props.complete,
  () => {
    showModal.value = false;
  },
);

onMounted(async () => {
  debug("Running mounted");
  if (props.activityIds && props.mandatory) {
    activityIds.value.push(props.activityId);
  }

  const plans = await cms.getDevelopPlans();
  const plan = plans.find((p) => p.strengthItemId === props.developPageDoc.data.strength_item_id);
  associatedPlan.value = plan || null;

  debug("Finished mounted handler");
});

function doSelfReview(): void {
  if (!props.complete && !showModal.value) {
    Analytics.action("Opened Questionnaire", "QuestionnaireActions", {
      pageId: props.pageId,
      pageUid: props.pageUid,
    });
    showModal.value = true;
  }
}

function selfReviewCancel(): void {
  showModal.value = false;
  Analytics.action("Cancelled Questionnaire", "QuestionnaireActions", {
    pageId: props.pageId,
    pageUid: props.pageUid,
  });
}

function selfReviewSubmit(answers: number[]): void {
  if (!props.complete) {
    Analytics.action("Completed Questionnaire", "QuestionnaireActions", {
      pageId: props.pageId,
      pageUid: props.pageUid,
    });
    emit("self-review-completed", props.activityId, answers);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["activity self-review-activity activity-with-button", { mandatory: _ctx.mandatory, complete: _ctx.complete }]),
    "activity-id": _ctx.activityId,
    onClick: doSelfReview,
    onKeydown: _withKeys(doSelfReview, ["enter"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_ctx.complete)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_8))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_11))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    (associatedPlan.value && associatedPlan.value.questions)
      ? (_openBlock(), _createBlock(QuestionsModal, {
          key: 0,
          questions: associatedPlan.value.questions,
          pageId: _ctx.pageId,
          "on-submit": selfReviewSubmit,
          "on-cancel": selfReviewCancel,
          showModal: showModal.value
        }, null, 8, ["questions", "pageId", "showModal"]))
      : _createCommentVNode("", true)
  ], 42, _hoisted_1))
}
}

})